export default "__VITE_ASSET__Boj_W8Ch__"